import { initializeApp, getApps, getApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const rawBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
// Firebase Storage buckets are typically "<project-id>.appspot.com".
// If someone pastes the new "firebasestorage.app" domain here, the SDK will
// generate REST URLs that often fail preflight in local dev.
const storageBucket = rawBucket?.endsWith('.firebasestorage.app')
  ? rawBucket.replace(/\.firebasestorage\.app$/, '.appspot.com')
  : rawBucket

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}

let app

if (!getApps().length) {
  app = initializeApp(firebaseConfig)
} else {
  app = getApp()
}

const db = getFirestore(app)
const storage = getStorage(app)

export { app, db, storage }

